import PropTypes from 'prop-types';

import { BarLoader } from 'react-spinners';
import { css } from '@emotion/react';

const OldWidgetLoadingIndicator = ({ color = '#ff5722' }) => {
    const loaderStyles = css`
        display: block;
        margin: 0 auto;
        color: #36d7b7;
        width: 100%;
    `;

    return (
        <div
            style={{
                position: 'absolute',
                bottom: 0,
                zIndex: 5,
                width: '100%',
            }}
        >
            <BarLoader
                color={color}
                loading={true}
                size={'100%'}
                css={loaderStyles}
            />
        </div>
    );
};

OldWidgetLoadingIndicator.propTypes = {
    color: PropTypes.string,
};

export default OldWidgetLoadingIndicator;
